import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### メッセージ使用数 API 操作クラス
 */
export default class UseMessageCounts {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET MonthlyCounts
   */
  public async getMonthlyCounts(userStore: LoginUser): Promise<number> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl = UrlFormatter.format(RestUrl.MessageMonthlyCount, formatParams);
    const response = await this.commonService.executeGet<{ count: number }>(userStore, requestUrl, this.constructor.name, null, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data.count;
  }

  /**
   * GET FunctionCounts
   */
  public async getFunctionCounts(userStore: LoginUser, queryParams: getFunctionCountsQuery): Promise<Array<FunctionCountGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl = UrlFormatter.format(RestUrl.MessageFunctionCount, formatParams);
    const response = await this.commonService.executeGet<Array<FunctionCountGetModel>>(userStore, requestUrl, this.constructor.name, queryParams, HitomeqErrorType.IGNORE, 0);

    return response.data;
  }

  /**
   * GET EveryHourCounts
   */
  public async getEveryHourCounts(userStore: LoginUser, queryParams: getEveryHourCountsQuery): Promise<Array<number>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl = UrlFormatter.format(RestUrl.MessageEveryHourCount, formatParams);
    const response = await this.commonService.executeGet<Array<number>>(userStore, requestUrl, this.constructor.name, queryParams, HitomeqErrorType.IGNORE, 0);

    return response.data;
  }
}

export interface getFunctionCountsQuery {
  start: number;
  end: number;
}

export interface getEveryHourCountsQuery {
  start: number;
  end: number;
}

/**
 * 機能別メッセージ
 */
export interface FunctionCountGetModel {
  functionType: number;
  count: number;
  name: string;
  graphColor: string;
}
